import { faArrowDown, faArrowUp, faTabletScreenButton } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Doughnut, Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
} from "chart.js";
import ChartDataLabels from 'chartjs-plugin-datalabels'; // Import the datalabels plugin
import { attendanceData, ipadData } from "../utils/attendancedashboard";
import React from "react";

// Register chart components and the datalabels plugin
ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  ChartDataLabels // Register the plugin
);

const IpadDevices = ({ipaddevicesuse}) => {
    const summary = ipaddevicesuse?.summary;

  const total = summary?.total ?? 0;
  const inUse = summary?.in_use ?? 0;
  const issues = summary?.issues ?? 0;

  const inUsePercentage = total > 0 ? ((inUse / total) * 100).toFixed(2) : 0;
  const issuesPercentage = total > 0 ? ((issues / total) * 100).toFixed(2) : 0;
  const doughnutData = {
    labels: ['In Use',  'Offline',],
    datasets: [
      {
        data: [inUsePercentage, issuesPercentage],
        backgroundColor: ['#F54900', '#FD9A00', '#009689', '#104E64'],
        borderWidth: 0,
      },
    ],
  };

const doughnutOptions = {
  cutout: '70%',
  layout: {
    padding: {
      top: 30,
      bottom: 20,
      left: 20,
      right: 20,
    },
  },
  plugins: {
    legend: {
      position: 'bottom',
      labels: {
        boxWidth: 12,
        padding: 15,
      },
    },
   datalabels: {
  color: '#000000',
formatter: (value, context) => {
        // Ensure value and total are valid numbers
        if (!value || isNaN(value)) return '0%';
        const data = context?.chart?.data?.datasets?.[0]?.data ?? [];
        const total = data.reduce((a, b) => a + (Number(b) || 0), 0);
        if (total === 0) return '0%'; // Avoid division by zero
        const percentage = ((value / total) * 100).toFixed(1);
        const label = context?.chart?.data?.labels?.[context.dataIndex] ?? ''; // Get the label
        return `${label} ${percentage}%`; // Format as "In Use 50%"
      },
      display: (context) => {
        const value = context?.dataset?.data?.[context?.dataIndex] ?? 0;
        const data = context?.dataset?.data ?? [];
        const total = data.reduce((a, b) => a + (Number(b) || 0), 0);
        if (total === 0) return false; // Avoid division by zero
        const percentage = (value / total) * 100;
        return percentage > 5; // Only show label if > 5%
      },
  anchor: 'end',
  align: 'end',
  offset: 0,
  clip: false,
  font: {
    size: 11,
    weight: 'bold',
  },
},

  },
  responsive: true,
  maintainAspectRatio: false,
};
const companies = ipaddevicesuse?.by_company ?? [];

const labels = companies.map(c => {
  if (c.company_name === 'INSTRUMENTATION & ELECTRICAL (I&E)') return 'I&E';
  return c.company_name.charAt(0) + c.company_name.slice(1).toLowerCase(); // Capitalize first letter
});

const availableData = companies.map(c => c.available ?? 0);
const issuesData = companies.map(c => c.issues ?? 0);
  const barData = {
    labels: ['Construction', 'Engineering', 'I&E'],
    datasets: [
      {
        label: 'Part 1',
        data:availableData,
        backgroundColor: '#F54900',
        stack: 'stack1',
        barThickness: 20,
      },
      {
        label: 'Part 2',
        data: issuesData,
        backgroundColor: '#009689',
        stack: 'stack1',
        barThickness: 20,
      },
    ],
  };

  const barOptions = {
    indexAxis: 'y',
    scales: {
      x: {
        min: 0,
        max: 60,
        ticks: {
          stepSize: 15,
        },
        stacked: true,
      },
      y: {
        stacked: true,
        ticks: {
          font: {
            size: 14,
          },
        },
      },
    },
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          boxWidth: 12,
          padding: 10,
        },
      },
      tooltip: {
        enabled: true,
      },
    },
    responsive: true,
    maintainAspectRatio: false,
  };
console.log(ipaddevicesuse,'ipadd')
  return (
    <div className="rounded-[12.75px] border border-black/10 bg-white shadow-[0px_1px_3px_0px_rgba(0,0,0,0.10),0px_1px_2px_-1px_rgba(0,0,0,0.10)] p-4 w-full max-w-[900px]">
      <div className="flex items-start gap-3 mb-4">
        <FontAwesomeIcon icon={faTabletScreenButton} className="text-xl mt-1" />
        <div>
          <div className="text-xl font-semibold">iPad Devices</div>
          <div className="text-sm text-[#717182]">Device usage analytics</div>
        </div>
      </div>

      {/* Container for charts */}
      <div className="flex flex-col sm:flex-row gap-8">
        <div className="w-full sm:w-1/2 flex flex-col items-center">
          <h2 className="text-sm font-semibold mb-3 text-center">Device status</h2>
          <div className="w-full h-[250px] ">
            <Doughnut data={doughnutData} options={doughnutOptions} />
          </div>
        </div>

        <div className="w-full sm:w-1/2 flex flex-col items-center">
          <h2 className="text-sm font-semibold mb-3 text-center">By Company</h2>
          <div className="w-full h-[200px]">
            <Bar data={barData} options={barOptions} />
          </div>
        </div>
      </div>
      <div>
        <div className="flex flex-wrap gap-2">
          {ipadData.map((item, index) => (
            <div
              key={index}
              className="relative p-4"
              style={{
                borderRadius: "12.75px",
                border: "1px solid rgba(0, 0, 0, 0.10)",
                background: "#FFF",
                boxShadow:
                  "0px 1px 3px 0px rgba(0, 0, 0, 0.10), 0px 1px 2px -1px rgba(0, 0, 0, 0.10)",
                minHeight: "130px",
                flex: "1 1 200px",
              }}
            >
              <div
                className="absolute top-3 right-3 p-2"
                style={{
                  borderRadius: "6.75px",
                  background: "rgba(255, 255, 255, 0.80)",
                  boxShadow:
                    "0px 1px 3px 0px rgba(0, 0, 0, 0.10), 0px 1px 2px -1px rgba(0, 0, 0, 0.13)",
                }}
              >
                {/* Icon or Image rendering */}
                {typeof item.icon === "string" ? (
                  <img src={item.icon} alt="icon" className="w-5 h-5 object-contain" />
                ) : React.isValidElement(item.icon) ? (
                  <span className="w-5 h-5">{item.icon}</span> // for inline SVG or JSX icons
                ) : (
                  <FontAwesomeIcon icon={item.icon} className="w-5 h-5" />
                )}
              </div>

              <div className="text-[#0A0A0A] text-sm font-semibold text-left">{item.title}</div>
              <div className="text-[#0A0A0A] text-2xl font-bold mt-1 text-left">
               {ipaddevicesuse?.summary?.[item.name] ?? '-'}

              </div>
              <div className="text-[#717182] text-sm mt-1 text-left">
                {item.description}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default IpadDevices;